import { reactive, computed } from "vue";
import type { Me, RunningJob } from "@/api/types";
import { getAccount } from "./msal";

// Tiny reactive user store. No Pinia — plan is explicit.
interface State {
  me: Me | null;
  loading: boolean;
  error: string | null;
}

const state = reactive<State>({
  me: null,
  loading: false,
  error: null,
});

export const authStore = {
  state,
  isSignedIn: computed(() => !!getAccount()),
  isAuthorized: computed(() => !!state.me && state.me.roles.length > 0),
  isAdmin: computed(() => !!state.me?.roles.includes("Playgrounds.Admin")),
  runningJobs: computed<RunningJob[]>(() => state.me?.runningJobs ?? []),
  setMe(me: Me | null) {
    state.me = me;
  },
  setLoading(v: boolean) {
    state.loading = v;
  },
  setError(e: string | null) {
    state.error = e;
  },
};
